import { VALIDATE_OTP_REGISTRATION } from '../api'
import axios from 'axios'

export const validateOtpRegistration = async (phoneNumber, otp) => {
    const ut = 'customer'
    const payload = { ut, phoneNumber, otp }
    try {
        const res = await axios.post(VALIDATE_OTP_REGISTRATION, payload)
        console.log(res)
        return res
    } catch (error) {
        return { success: false, error: error.message }
    }
}
